export default "__VITE_ASSET__BUclAZIc__"